import { Injectable } from '@angular/core';

/**
 * Carries a "open this specific template on arrival" request from the launch URL
 * to whichever component owns template selection.
 *
 * Read once with consume(). The value is cleared on read so that a later entity
 * change, refresh, or a second template list rendering does not re-launch.
 */
@Injectable({ providedIn: 'root' })
export class TemplateLaunchIntentService {
  private templateId: string | undefined;

  /**
   * Records a template launch request captured from the launch URL.
   */
  set(templateId: string): void {
    this.templateId = templateId;
  }

  /**
   * True while a launch request is still waiting to be honoured.
   */
  isPending(): boolean {
    return this.templateId !== undefined;
  }

  /**
   * Returns the pending template id and clears it
   */
  consume(): string | undefined {
    const pending = this.templateId;
    this.templateId = undefined;
    return pending;
  }
}
